/**
 * Config for authentication form fields. Defines the attributes passed to
 * cognito-idp during each phase of of user-reistration. Passed as argument to
 * `AuthProvider`.
 */
export const authFormFields = {
    signIn: {
        username: {
            label: "Email Address",
            placeholder: "Enter your email",
            isRequired: true,
        },
    },
    signUp: {
        profile: {
            order: 1,
        },
        given_name: {
            order: 2,
        },
        family_name: {
            order: 3,
        },
        username: {
            order: 4,
        },
        password: {
            order: 5,
        },
        confirm_password: {
            order: 6,
        },
    },
    forceNewPassword: {
        password: {
            label: "New Password",
            placeholder: "Enter your Password",
        },
    },
    resetPassword: {
        username: {
            label: "Email Address",
            placeholder: "Enter email",
            isRequired: true,
        },
    },
    confirmResetPassword: {
        confirmation_code: {
            placeholder: "Enter your Confirmation Code",
            isRequired: true,
        },
        confirm_password: {
            placeholder: "Enter your Password Please",
            isRequired: true,
        },
    },
    setupTOTP: {
        QR: {
            placeholder: "Scan the QR Code",
            isRequired: true,
        },
    },
    confirmSignIn: {
        confirmation_code: {
            label: "Enter confirmation code from your Authenticator App",
            placeholder: "Enter confirmation code",
            isRequired: false,
        },
    },
}
